import React from 'react';
import Header from './Header';
import Footer from './Footer';
import './PageLayout.css';

/**
 * Wraps inner pages with Header and Footer. Use for About, Tracks, Courses, etc.
 */
const PageLayout = ({ children, className = '' }) => (
  <>
    <Header ctaText="Join Community" ctaPath="#courses" />
    <main className={`page-layout-main ${className}`}>
      {children}
    </main>
    <Footer />
  </>
);

export default PageLayout;
